import React from 'react'
import Select from 'react-select'
import { isEqual } from 'lodash'
import { fnum, sortOpts } from '../../utils/utils'
import Form from '../ui/Form'

class PRSAddSubTotal extends Form {
  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      errors: {}
    };
  }

  savePost = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(this.props.data, data)) {
      this.props.cancelAdd();
    }
    else {
      this.props.editPost(data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelAdd();
        const diffP = data.post_price*data.post_qntt;
        this.props.updtBlnc(diffP, diffP, 0);
      });
    }
  }

  cancelEdit = e => {
    e.preventDefault();
    this.props.cancelAdd();
  }

  updateSrvc = e => {
    let { post_desc } = this.state.data;
    if(post_desc.length === 0){
      const srvc = this.props.srvcs[e.value];
      post_desc = srvc.srvc_longdesc || srvc.srvc_desc;
    }
    this.setState({
      data: {
        ...this.state.data,
        post_srvc_id: e.value,
        post_srvg_id: this.props.srvcs[e.value].srvc_srvg_id,
        post_desc
      }
    });
  }

  render() {
    const { srvgs, srvcs, type } = this.props;

    const { data, errors } = this.state;

    var srvcsOpt = [];
    for (var key in srvcs){
      if(srvcs.hasOwnProperty(key) && ((srvcs[key].srvc_active === 1
        && srvgs[srvcs[key].srvc_srvg_id].srvg_subtotal === type)
        || srvcs[key].srvc_id === data.post_srvc_id)) {
        srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    srvcsOpt.sort(sortOpts);

    return (
      <tr>
        <td>
          <div className="form-group">
            <button  type="button" className="btn btn-success btn-xs"
              onClick={this.savePost}
              title="Сохранить"
            >
              <span className="glyphicon glyphicon-save"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-default btn-xs"
              onClick={this.props.cancelAdd}
              title="Отменить"
            >
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Услуга</label>&nbsp;
              <div style={{flex: 1, width: 0}}>
                <Select
                  clearable={false}
                  options={srvcsOpt}
                  value={data.post_srvc_id}
                  onChange={this.updateSrvc}
                  autofocus
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              name="post_desc"
              value={data.post_desc}
              cols="80"
              rows="5"
              title="Описание"
              placeholder="Описание"
              onChange={this.updateInput}
            />
          </div>
        </td>
        <td>
          <input type="text"
            className="form-control text-editable"
            value={data.post_price}
            name="post_price"
            onChange={this.updateInput}
          />
        </td>
        <td>1</td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td></td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td>
          <textarea type="text"
            className="form-control"
            value={data.post_note}
            rows="3"
            placeholder="Заметка"
            title="Заметка"
            name="post_note"
            onChange={this.updateInput}
          />
        </td>
      </tr>
    );
  }
}

export default PRSAddSubTotal;



// WEBPACK FOOTER //
// ./src/components/prs/PRSAddSubTotal.js